import { clsx as o } from "../../node_modules/.pnpm/clsx@1.2.1/node_modules/clsx/dist/clsx.m.js";
import { twMerge as t } from "../../node_modules/.pnpm/tailwind-merge@2.2.1/node_modules/tailwind-merge/dist/bundle-mjs.js";
function n(...r) {
  return t(o(r));
}
export {
  n as cn
};
